export default __webpack_public_path__ + "1f9c0ca47677a6f55e8165f9b87c4cd6.png";